import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getAllProducts = createAsyncThunk(
  "all-products",
  async ({ filters = "", page = "", price = "" }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      for (const key in filters) {
        const value = filters[key];

        if (Array.isArray(value) && value.length > 0) {
          // Map the array of objects to an array of just their IDs
          // if (key === "priceRange") {
          //   params.append(key, value.join(","));
          // } else {
          const ids = value.map((item) => item.id);
          params.append(key, ids.join(","));
          // }
        } else if (typeof value === "string" && value) {
          params.append(key, value);
        }
      }

      params.append("page", page);
      params.append("priceRange", price);
      const Data = await GET(
        API.GET_ALL_PRODUCTS + `?per_page=${9}&${params.toString()}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsLoder = createAsyncThunk(
  "all-products-loder",
  async (
    { filters = "", page = "", price = "", setLoder },
    { rejectWithValue },
  ) => {
    try {
      setLoder(true);
      const params = new URLSearchParams();

      for (const key in filters) {
        const value = filters[key];

        if (Array.isArray(value) && value.length > 0) {
          // Map the array of objects to an array of just their IDs
          // if (key === "priceRange") {
          //   params.append(key, value.join(","));
          // } else {
          const ids = value.map((item) => item.id);
          params.append(key, ids.join(","));
          // }
        } else if (typeof value === "string" && value) {
          params.append(key, value);
        }
      }

      params.append("page", page);
      params.append("priceRange", price);
      const Data = await GET(
        API.GET_ALL_PRODUCTS + `?per_page=${15}&${params.toString()}`,
      );

      setLoder(false);
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllTopProducts = createAsyncThunk(
  "all-products-material",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.Top_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllTrandingProducts = createAsyncThunk(
  "all-products-shape",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.Tranding_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsNewLaunch = createAsyncThunk(
  "all-products-newlaunch",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllOURProduct = createAsyncThunk(
  "all-products-populer",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceRange,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `?category=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceRange=${priceRange || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const getAllEyeGlasses = createAsyncThunk(
  "all-eey",
  async (
    { filters = "", page = "", price = "", eyegalss_status = true },
    { rejectWithValue },
  ) => {
    try {
      const params = new URLSearchParams();

      for (const key in filters) {
        const value = filters[key];

        if (Array.isArray(value) && value.length > 0) {
          // Map the array of objects to an array of just their IDs
          // if (key === "priceRange") {
          //   params.append(key, value.join(","));
          // } else {
          const ids = value.map((item) => item.id);
          params.append(key, ids.join(","));
          // }
        } else if (typeof value === "string" && value) {
          params.append(key, value);
        }
      }

      params.append("page", page);
      params.append("eyegalss_status", eyegalss_status);
      params.append("priceRange", price);
      const Data = await GET(
        API.GET_ALL_PRODUCTS + `?per_page=${9}&${params.toString()}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
// export const getAllEyeGlasses = createAsyncThunk(
//   "all-eyeglasses",
//   async (
//     {
//       category_id,
//       subcategory_id,
//       childcategory_id,
//       brand_id,
//       name,
//       priceOrder,
//       type = "",
//       need_id,
//     },
//     { rejectWithValue },
//   ) => {
//     try {
//       const Data = await GET(
//         API.GET_PRODUCTS +
//           `/eyeglasses-products?category=${category_id || ""}&sub_category_id=${subcategory_id ||
//             ""}&child_category_id=${childcategory_id || ""}` +
//           `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
//             ""}&priceOrder=${priceOrder || ""}`,
//       );
//       return Data?.data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

// Thunk for gettingStore
export const getProduct = createAsyncThunk(
  "product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getLinkedProduct = createAsyncThunk(
  "linked-product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_LINKED_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getGroupByProduct = createAsyncThunk(
  "group-by-product",
  async ({ p_category_id }, { rejectWithValue }) => {
    try {
      const data = await GET(
        API.GET_ALL_PRODUCT_GROUP_BY_SUB_CATEGORIES +
          `?p_category_id=${p_category_id || ""}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const pincodeCheck = createAsyncThunk(
  "auth/product-pincode",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/${data?.product_id}`,
        data,
      );

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting Add banners

// Thunk for getting Add banners
export const getspecialitystatus = createAsyncThunk(
  "product/add-specialstatus",
  async (_, { rejectWithValue }) => {
    try {
      const specialstatusData = await GET(API.GET_SPECIAL_STATUS);
      return specialstatusData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const SendWhatApp = createAsyncThunk(
  "auth/send",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/whatapp-send`,
        data,
      );

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

export const SendWhatAppContact = createAsyncThunk(
  "auth/send-contact",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/incontact-whatapp-send`,
        data,
      );

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

export const ProductSearch = createAsyncThunk(
  "auth/product-search",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(API.GET_PRODUCT_SEARCH, data);

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};
// Create the slice
const productSlice = createSlice({
  name: "product",
  initialState: {
    allProducts: [],
    allProductsLoder: [],
    allProductsTranding: [],
    trendingProducts: [],
    allProductsTop: [],

    allProductsNewLaunch: [],
    allOurProducts: [],
    product: {},
    eyeglasses_product: [],
    linked_products: [],
    addSpecialstatus: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.status = "loading";
        console.log("State after pending.....", state);
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProducts = action.payload || [];
        console.log("State after fulfilled.........", state);
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected.....", state);
      })

      .addCase(getAllProductsLoder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending.....", state);
      })
      .addCase(getAllProductsLoder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProductsLoder = action.payload || [];
        console.log("State after fulfilled.........", state);
      })
      .addCase(getAllProductsLoder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected.....", state);
      })

      .addCase(getAllEyeGlasses.pending, (state) => {
        state.status = "loading";
        console.log("State after pending.....", state);
      })
      .addCase(getAllEyeGlasses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.eyeglasses_product = action.payload || [];
        console.log("State after fulfilled.........", state);
      })
      .addCase(getAllEyeGlasses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected.....", state);
      })
      .addCase(getAllTopProducts.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllTopProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductsTop = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllTopProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllTrandingProducts.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllTrandingProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductsTranding = action.payload || [];
        state.trendingProducts = action.payload || []; // NEW
        console.log("State after fulfilled", state);
      })
      .addCase(getAllTrandingProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
      .addCase(getAllProductsNewLaunch.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllProductsNewLaunch.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductsNewLaunch = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllProductsNewLaunch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllOURProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllOURProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allOurProducts = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllOURProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "Response payload combination in fulfilled case:",
          action.payload,
        );
        state.product = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getLinkedProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getLinkedProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.linked_products = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getLinkedProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getGroupByProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getGroupByProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProductsTranding = action.payload || [];
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(getGroupByProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(pincodeCheck.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(pincodeCheck.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(pincodeCheck.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(SendWhatApp.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(SendWhatApp.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(SendWhatApp.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(SendWhatAppContact.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(SendWhatAppContact.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(SendWhatAppContact.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(ProductSearch.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(ProductSearch.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(ProductSearch.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(getspecialitystatus.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getspecialitystatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addSpecialstatus = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getspecialitystatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default productSlice.reducer;